import { isNode } from "@walletconnect/environment";
export const isNodeJs = isNode;
export * from "@walletconnect/environment";
